import { $analytics } from '../y/analytics';
import { $api } from '../y/api';

export function subscribeNewsletter(email: string, newsletter: string) {
    return $api.POST('newsletter', { email, newsletter }).then(() => {
        $analytics.track('Newsletter subscription', { email, newsletter });
    });
}

